module.exports = __webpack_public_path__ + "media/custom/images/pocstock-signup-contributor-87d91ab5305de6bde5291c8d8d406bff.png";